var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PersonFilled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.871 46.7714C81.871 53.1858 76.6711 58.3858 70.2567 58.3858C63.8422 58.3858 58.6423 53.1858 58.6423 46.7714C58.6423 40.357 63.8422 35.1571 70.2567 35.1571C76.6711 35.1571 81.871 40.357 81.871 46.7714ZM93.4854 46.7714C93.4854 59.6003 83.0855 70.0001 70.2567 70.0001C57.4278 70.0001 47.028 59.6003 47.028 46.7714C47.028 33.9426 57.4278 23.5427 70.2567 23.5427C83.0855 23.5427 93.4854 33.9426 93.4854 46.7714ZM41.2208 110.65C41.2208 101.029 49.0207 93.2288 58.6423 93.2288H81.871C91.4926 93.2288 99.2925 101.029 99.2925 110.65C99.2925 113.858 101.892 116.458 105.1 116.458C108.307 116.458 110.907 113.858 110.907 110.65C110.907 94.6143 97.9071 81.6145 81.871 81.6145H58.6423C42.6062 81.6145 29.6064 94.6143 29.6064 110.65C29.6064 113.858 32.2064 116.458 35.4136 116.458C38.6208 116.458 41.2208 113.858 41.2208 110.65Z",
    fill: "white",
    fillOpacity: 0.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFilled);
export default __webpack_public_path__ + "static/media/PersonFilled.0d56d21ad014325dcefb7a335c52b10b.svg";
export { ForwardRef as ReactComponent };